import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TechExecutiveCard from "./TechExecutiveManagementCard";
import { getTechnicalExecutiveInfo, getResetPassword } from "../Actions/ManagementAPI";

class TechExecutive extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchData: {
                Name: '',
                PageNumber: 1,
                PageSize: 25
            }
        }
        this.SearchData = this.SearchData.bind(this);
        this.ClearInput = this.ClearInput.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        this.props.dispatch({ type: 'SubBannerTitle', data: "Technical Executive" });
        this.props.dispatch(getTechnicalExecutiveInfo(this.state.searchData));
    }

    SearchData(Pgno) {
        const { dispatch } = this.props;
        this.state.searchData.PageNumber = Pgno;
        dispatch(getTechnicalExecutiveInfo(this.state.searchData));
    }

    ClearInput() {
        this.state.searchData.Name = "";
        this.props.dispatch(getTechnicalExecutiveInfo(this.state.searchData));
        this.setState({});
    }

    // eyeclick(item) {
    //     const { dispatch, history } = this.props;
    //     dispatch({ type: "ShowSidePan", data: true });
    //     dispatch({ type: "StaffDetails", data: item });
    //     history.push(`/Home/Management/FleetManager/${item.staffId}`);
    //     window.scrollTo(0, 0);
    // }

    resetPasswordclick(item){
        this.props.dispatch(getResetPassword(item));
    }

    handleInputChange(e) {
        this.state.searchData.Name = e.target.value;
        if (e.target.value === "") {
            this.props.dispatch(getTechnicalExecutiveInfo(this.state.searchData));
        }
        this.setState({});
    }

    hideSidePanel = () => {
        this.props.history.goBack();
        this.props.dispatch({ type: "ShowSidePan", data: false });
    }
    
      NewitemNav = () => {
        this.props.history.push("/Home/Management/TechExecutiveAdd");
      };


    render() {
        const { TechExecutiveInfoList } = this.props;
        return (
            <div className="full-height">
                <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3"
                    onClick={() => this.hideSidePanel()}
                >
                    &larr; Back
                        </button>
                <div className="pt-3">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="panel-box">
                                        <div className="card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                                            <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                                                <h5 className="card-title ml-2 mt-2 f2" style={{ color: "092a51" }}>Technical Executive</h5>
                                               <div className="m-1 flex" onClick={this.NewitemNav}>
                                                    <span className="mt-1">Add</span><AddIcon />
                                                </div> 
                                            </div>
                                        </div>
                                        <div className="search-filter-box">
                                            <div className="row">
                                                <div className="col-lg-6 ">
                                                    <label className="form-label" >Name</label><br></br>
                                                    <input className="form-control" type="text" name="name" placeholder="Name" value={this.state.searchData.Name} onChange={e => this.handleInputChange(e)}></input>
                                                </div>
                                                <div className="col-lg-6">
                                                    <label></label><br></br>
                                                    <div className="form-group mt-3 search-btn-col" style={{ textAlign: "end" }}>
                                                        <button
                                                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                            type="submit" onClick={() => this.SearchData(1)}>
                                                            Search
                                                        </button>
                                                        <button
                                                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                            type="button" onClick={() => this.ClearInput()}>
                                                            {" "} Clear{" "}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {TechExecutiveInfoList ?
                                <TechExecutiveCard
                                    arraylist={TechExecutiveInfoList.data}
                                    pageSize={TechExecutiveInfoList.pagination.pageSize}
                                    currentPage={TechExecutiveInfoList.pagination.currentPage}
                                    totalRecords={TechExecutiveInfoList.pagination.totalcount ? TechExecutiveInfoList.pagination.totalcount : 0}
                                    setUpdatedState={(value) => this.SearchData(value)}
                                    eyeclick={(item) => this.eyeclick(item)}
                                    resetPasswordclick={(item) => this.resetPasswordclick(item.email)}
                                />
                                : ''}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    openEditScreen() {
        this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.push("/Home/EditClient");
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        showSidePane: state.SidePanReducer.sidePan || false,
        TechExecutiveInfoList: state.MasterScreenReducer.TechExecutiveInfoList
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TechExecutive));